// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r-j2","col":"styles_col__347gE","actions":"styles_actions__1SNfR","conflict":"styles_conflict__3FoRi"};